module.exports = __webpack_public_path__ + "media/images/pay-828708729503b7384834e2654b46b3fbe4dc6262841b7f744113d6c026a9213d.jpg";